(function () {
  if (customElements.get('mockup-rotator')) return;

  // Tick GLOBAL sincronizado: todas las tarjetas cambian a la vez.
  // Cada tarjeta renderiza su secuencia con un offset distinto del mismo
  // pool de combos (metafield mockups_showcase), así dos tarjetas nunca
  // muestran el mismo modelo+color al mismo tiempo.
  var INTERVAL = 3500;
  var registry = [];
  var timer = null;

  function tick() {
    for (var i = 0; i < registry.length; i++) registry[i].next();
  }

  function sync() {
    if (registry.length && !timer) {
      timer = setInterval(tick, INTERVAL);
    } else if (!registry.length && timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  customElements.define(
    'mockup-rotator',
    class MockupRotator extends HTMLElement {
      connectedCallback() {
        this.images = Array.prototype.slice.call(this.querySelectorAll('.card-showcase__img'));
        this.index = 0;
        var wrapper = this.closest('.card-wrapper');
        this.links = wrapper
          ? Array.prototype.slice.call(wrapper.querySelectorAll('a[href*="/products/"]'))
          : [];
        this.syncLinks();
        if (this.images.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (registry.indexOf(this) === -1) registry.push(this);
        sync();
      }

      disconnectedCallback() {
        var i = registry.indexOf(this);
        if (i !== -1) registry.splice(i, 1);
        sync();
      }

      // El título y el botón "Personalizar" abren la PDP con el modelo y
      // color del mockup visible en ese momento (?model=&color=, el mismo
      // formato que usa el generador aleatorio y que lee product-v2.js)
      syncLinks() {
        var img = this.images[this.index];
        if (!img) return;
        var model = img.getAttribute('data-model');
        var color = img.getAttribute('data-color');
        if (!model || !color) return;
        var query = '?model=' + encodeURIComponent(model) + '&color=' + encodeURIComponent(color);
        for (var i = 0; i < this.links.length; i++) {
          var base = this.links[i].getAttribute('href').split('?')[0];
          this.links[i].setAttribute('href', base + query);
        }
      }

      next() {
        this.images[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.images.length;
        this.images[this.index].classList.add('is-active');
        this.syncLinks();
      }
    }
  );
})();
